import {
  QrcodeOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { formatAxiosError } from "../../../../utils/common";
import { fetchSicfeDocument, getSicfeDocumentId } from "../../../../utils/sicfeUtils";
import { DownloadDocumentButton, PostInvoiceButton, ConfirmationFormSection, InvoiceTicket, InvoiceHeader } from "../../common/components";
import { ClientSectionSlot } from "./ClientSectionSlot";
import { BillingInfoSectionSlot as BillingInfoSection } from "../../common/components";

//************************************InvoiceForm.js slots************************************
/**
 * COMPONENTE SLOT PARA LA SECCIÓN "CONFIRMACION"
 * Se renderizará en onSubmit de la nueva factura para corroborar datos de facturacion
 */
export { ConfirmationFormSection };

export { ClientSectionSlot as ClientSection, BillingInfoSection, InvoiceHeader as InvoiceHeaderSlot };

/**
 * COMPONENTE SLOT PARA LA SECCIÓN "TICKET"
 * Se renderizará al confirmar factura.
 */
export const TicketSection = (props) => (
  <InvoiceTicket {...props} />
);

//************************************InvoiceList.js methods************************************
const handleSicfeDocumentDownload = async (invoice, esTicket, setLoading) => {
  try {
    setLoading(true)
    let id = await getSicfeDocumentId(invoice.Pre_Assigned_No);
    if (id == "" || id == null) {
      window.messageApi.error("Documento no encontrado.");
    }
    else {
      await fetchSicfeDocument(id, esTicket);
    }
    setLoading(false)
  }
  catch (error) {
    setLoading(false)
    const message = formatAxiosError(error, "Error al consultar documento.");
    window.messageApi.error(message, { modal: true });
  }
}

//************************************InvoiceList.js slots************************************
export const DownloadTicketButton = (props) => (
  <DownloadDocumentButton
    {...props}
    icon={<QrcodeOutlined />}
    title="Descargar ticket QR"
    onDownload={(invoice, setLoading) =>
      handleSicfeDocumentDownload(invoice, true, setLoading)
    }
  />
);

export const DownloadInvoiceButton = (props) => (
  <DownloadDocumentButton
    {...props}
    icon={<FilePdfOutlined />}
    title="Descargar factura"
    onDownload={(invoice, setLoading) =>
      handleSicfeDocumentDownload(invoice, false, setLoading)
    }
  />
);

export { PostInvoiceButton };
